function isCompositeMonorailEvent(monorailEvent) {
  return monorailEvent.schemaId !== undefined;
}

export { isCompositeMonorailEvent };
